<template>
  <PageTemplate>
    <v-container class="pt-10 pb-12">
      <Title class="text-center">Notícias e Releases</Title>

      <Loading v-if="loading" />

      <div v-else class="mt-10">
        <v-row v-if="items.length">
          <v-col cols="6" md="4" lg="3" v-for="(item, key) in items" :key="key">
            <ArticlesCard :item="item" />
          </v-col>

          <v-col v-if="pagesLength > 1" class="mt-10" cols="12">
            <v-pagination
              v-model="page"
              :length="pagesLength"
              :total-visible="totalVisibles"
            ></v-pagination>
          </v-col>
        </v-row>

        <v-alert v-else type="warning" class="mt-10">
          Nenhum item adicionado até o momento.
        </v-alert>
      </div>
    </v-container>
  </PageTemplate>
</template>

<script>
import PageTemplate from "../../templates/Page.vue";
import Loading from "../../widgets/Loading.vue";
import Title from "../../widgets/Title.vue";
import ArticlesCard from "../../cards/Articles.vue";
import { formatToURL } from "../../../utils/formatToURL";

const _config = {
  path: "/imprensa/noticias",
  mod: "articles",
};

export default {
  data: () => ({
    loading: true,
    items: [],
    path: _config.path,
    itemsPerPage: 24,
    totalItems: 0,
  }),
  computed: {
    page: {
      get() {
        const p = this.$route.query.p;
        return p ? parseInt(p) : 1;
      },
      set(v) {
        const query = { ...this.$route.query };
        query.p = v;

        return this.$router.push({ query });
      },
    },
    pagesLength() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    totalVisibles() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 1;
        case "sm":
          return 5;
        default:
          return 9;
      }
    },
  },
  created() {
    this.get();
  },
  watch: {
    page() {
      this.get();
    },
    $route() {
      this.get();
    },
  },
  methods: {
    get() {
      const params = {
        itemsPerPage: this.itemsPerPage,
        returnTotalItems: 1,
      };

      if (this.page) params.page = this.page;

      this.loading = true;

      this.$rest(_config.mod)
        .get({
          params,
          keepCache: true,
          save: (state, { totalItems, list }) => {
            this.items = list.map(({ id, img, title, date }) => ({
              img,
              title,
              date,
              to: `${this.path}/${formatToURL(title)}-${id}`,
            }));
            this.totalItems = totalItems;

            if (!list.length && this.page > 1) this.page = 1;
          },
        })
        .then(() => (this.loading = false));
    },
  },
  components: {
    PageTemplate,
    Loading,
    Title,
    ArticlesCard,
  },
};
</script>
